import React, { useState } from 'react';

import { useDebouncedValue, useDisclosure } from '@mantine/hooks';
import AthleteDocumentsTable from 'pages/private/owner/AthleteDetail/components/Documents/components/AthleteDocumentsTable';
import ContractCreateModal from 'pages/private/owner/AthleteDetail/components/Documents/components/ContractCreateModal';
import DocumentSignModal from 'pages/private/owner/AthleteDetail/components/Documents/components/DocumentSignModal';
import WaiverCreateModal from 'pages/private/owner/AthleteDetail/components/Documents/components/WaiverCreateModal';
import { AthleteDocumentSearchFilters } from 'pages/private/owner/AthleteDetail/components/Documents/types';
import { AthleteRetrieve } from 'types';

import AthleteDocumentsHeader from './components/AthleteDocumentsHeader';

const Documents = ({
  athlete,
  openTabsDrawer,
  permission = true,
}: {
  athlete: AthleteRetrieve;
  openTabsDrawer: () => void;
  permission?: boolean;
}): JSX.Element => {
  const initialFilterValues = {
    athleteId: athlete.athleteId,
    search: '',
    type: null,
    isSigned: null,
  };

  const [searchFilters, setSearchFilters] = useState<AthleteDocumentSearchFilters>(initialFilterValues);
  const [debouncedSearchFilters] = useDebouncedValue<AthleteDocumentSearchFilters>(searchFilters, 250);
  const [isCreateWaiverOpened, { toggle: handleCreateWaiverToggle }] = useDisclosure(false);
  const [isCreateContractOpened, { toggle: handleCreateContractToggle }] = useDisclosure(false);
  const [isSignModalOpened, { toggle: handleSignModalToggle }] = useDisclosure(false);
  const [documentId, setDocumentId] = useState<string>('');

  const handleSignModalClose = (): void => {
    handleSignModalToggle();
    setDocumentId('');
  };

  return (
    <>
      <AthleteDocumentsHeader
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        openCreateWaiver={handleCreateWaiverToggle}
        openCreateContract={handleCreateContractToggle}
        openTabsDrawer={openTabsDrawer}
        permission={permission}
      />

      <AthleteDocumentsTable
        searchFilters={debouncedSearchFilters}
        openSignModal={handleSignModalToggle}
        setDocumentId={setDocumentId}
        permission={permission}
        margin={0}
        bgc={'gray'}
      />

      <ContractCreateModal
        opened={isCreateContractOpened}
        closeHandler={handleCreateContractToggle}
        athlete={athlete}
      />

      <WaiverCreateModal
        athlete={athlete}
        opened={isCreateWaiverOpened}
        closeHandler={handleCreateWaiverToggle}
      />

      <DocumentSignModal
        opened={isSignModalOpened}
        closeHandler={handleSignModalClose}
        documentId={documentId}
        permission={permission}
      />
    </>
  );
};

export default Documents;
